import React, { useEffect, useState } from 'react'
import { Card, Container, Tab, Tabs } from 'react-bootstrap';
import AllTeachersTable from './AllTeacher.table';
import { BeatLoader } from 'react-spinners';
import Table from './Table';
import axios from 'axios';
import moment from 'moment';
import { AdminService } from '../../../../../services/admin.service';
import toast from 'react-hot-toast';

export default function AllTeachersIndex() {
    const [data, setData] = useState<any>();
    const [tab, setTab] = useState('active')
    const [searchInput, setSearchInput] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedUser, setSelectedUser] = useState<any>()
    const [selectedUser1, setSelectedUser1] = useState<any>()
    const [instructors, setInstructors] = useState<any[]>([]);


     useEffect(() => {
        fetchInstructors()
        // eslint-disable-next-line 
    }, [])

    useEffect(() => {
        if(data) formatData(data.instructor, data.courses)
    }, [data])

    const fetchInstructors = async () =>{
        try{

            await AdminService.getAllInstructors().then((res)=>{
                if(res.status===200){
                    setData(res.data)
                }
            })
            .catch((err) => {
                console.log(err)

            })

        } catch(err){
            console.log(err)
        }
    }

    const formatData = (data:any, courses:any) => {
        setInstructors(data.map((item:any) => {
            const teacher_courses = courses.filter((item1:any) => {
                return item1.instructor_profile._id === item._id
            })
            // console.log(teacher_courses)
            return {
                ...item,
                name: {value: item.user.firstName + ' ' + item.user.lastName, label: <NameWithAvatar name = {item.user.firstName + ' ' + (item.user.lastName || '')} avatar = {item.user.avatar} />},
                email: item.user.email,
                phone: item.user.phone,
                signupDate: {value: moment(item.createdAt).unix(), label: moment(item.createdAt).format('Do MMM YY, hh:mm A')},
                approved: item.approve ? 'Approved' : 'Not Approved',
                teachesChildren: item.teachesChildren ? 'Yes': 'No',
                isRecordingAllowed: item.isRecordingAllowed ? 'Yes' : 'No',
                isEdited: {value: item.isEdited ? 'b' : 'a', label: item.isEdited ? <div className = "btn btn-primary btn-sm" onClick = {() => setSelectedUser1(item._id)}>Mark</div> : "Not edited"},
                rating: Number((teacher_courses.reduce((a:any, b:any) => a + b.reviews.reduce((a1:any, b1:any) => a1 + b1.rating, 0), 0))/(teacher_courses.reduce((a:any, b:any) => a + b.reviews.length, 0))).toFixed(2),
                courses: teacher_courses.map((item:any) => item.instrument),
                onboarded: item.onboarding.complete === undefined ? 'Pending' : 'Completed',
                hideUser: {value: '', label: <div className = "btn btn-primary btn-sm" onClick = {() => setSelectedUser(item._id)}>{item.hideAdminDashboard ? "Unhide" : "Hide"} </div>},
                instrument_teach: item.user.instrumentToTeach
            }
        }).sort((a:any, b:any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()))
    }


    useEffect(() => {
        if(selectedUser && selectedUser.length > 5) blockAccount(selectedUser)
         // eslint-disable-next-line 
    }, [selectedUser])
   
    useEffect(() => {
        if(selectedUser1 && selectedUser1.length > 5) markAccount(selectedUser1)
         // eslint-disable-next-line 
    }, [selectedUser1])


    const blockAccount = async (id:any) => {
        try{

            // setSelectedUser()
            const newData = [...data.instructor];
            const index1= newData.findIndex(item => item._id === id);
            let value = newData[index1].hideAdminDashboard;
            newData[index1].hideAdminDashboard = !value
            setData((prev:any) => ({instructor: newData, ...prev}))

            if(!value){
                await AdminService.hideInstructor(id).then((res) => {
                    if (res.status == 200) {
                        toast.success("Instructor Hided");
                    }
                })
                .catch((err) => {
                    console.log(err);
                    toast.error("Something went wrong");
                })
                
            } else{
                await AdminService.unhideInstructor(id).then((res) => {
                    if (res.status == 200) {
                        toast.success("Instructor Unhided");
                    }
                })
                .catch((err) => {
                    console.log(err);
                    toast.error("Something went wrong");
                })
            }

        } catch(err){
            console.log(err)
        }
    }
    
    
    const markAccount = async (id:any) => {
        try{

            // setSelectedUser1()
            const newData = [...data.instructor];
            const index1= newData.findIndex(item => item._id === id);
            // let value = newData[index1].hideAdminDashboard;
            newData[index1].isEdited = false;
            setData((prev:any) => ({instructor: newData, ...prev}))
            await AdminService.markInstructor(id).then((res)=>{
                if(res.status==200){
                    toast.success("Marked");
                }
            })
            .catch((err)=>{
                console.log(err);
                toast.error("Something went wrong");
            })

        } catch(err){
            console.log(err)
        }
    }


    return (
        <>
            <div className='header mt-0 mx-4'>
                <div className='header-body'>
                    <div className='row align-items-end'>
                        <div className='col'>
                            <h3 className='h2 mb-0' style={{fontFamily:'sans-serif',color:'#312978'}}>INSTRUCTORS</h3>
                        </div>
                        <div className='col-auto'>
                            <AccountNav tab={tab} setTab={setTab} />
                        </div>
                    </div>
                </div>
            </div>
            {!instructors && <BeatSpinner2 />}
            {(instructors && tab === 'all') && <Table 
                data = {instructors}
                isSelectable = {false}
                headers = {headers.filter(item => item.value !== 'hideUser')}
                isSearchable = {true}
                handleRowClick = {(id:any) => window.open(`/admin/search/instructor/detail/${id}`, "_blank")}
                isHeader = {true}
                isFooter = {true}
                isSortable = {false}
                searchInput = {searchInput}
                setSearchInput = {setSearchInput}
                filters = {[]}
                isDownloadable = {true}
            />}
            {(instructors && tab === 'active') && <Table 
                data = {instructors.filter(item => !item.hideAdminDashboard)}
                isSelectable = {false}
                headers = {headers}
                isSearchable = {true}
                handleRowClick = {(id:any) => window.open(`/admin/search/instructor/detail/${id}`, '_blank')}
                isHeader = {true}
                isFooter = {true}
                isSortable = {false}
                searchInput = {searchInput}
                setSearchInput = {setSearchInput}
                filters = {[]}
                isDownloadable = {true}
            />}
            {(instructors && tab === 'archieved') && <Table 
                data = {instructors.filter(item => item.hideAdminDashboard)}
                isSelectable = {false}
                headers = {headers}
                isSearchable = {true}
                handleRowClick = {(id:any) => window.open(`/admin/search/instructor/detail/${id}`, '_blank')}
                isHeader = {true}
                isFooter = {true}
                isSortable = {true}
                searchInput = {searchInput}
                setSearchInput = {setSearchInput}
                filters = {[]}
                isDownloadable = {true}
            />}
        </>
    )
};


const AccountNav = ({ tab, setTab }: any) => {
    return (
        <div className="row align-items-center">
            <div className="col">
                <ul className="nav nav-tabs nav-overflow header-tabs">
                    <li className="nav-item" style={{cursor: 'pointer'}}>
                        <div className={`nav-link  ${tab === 'all' ? 'active' : ''} px-1`} onClick={() => setTab('all')}>All Instructors</div>
                    </li>
                    <li className="nav-item" style={{cursor: 'pointer'}}>
                        <div className={`nav-link ${tab === 'active' ? 'active' : ''} px-1`} onClick={() => setTab('active')}>Active</div>
                    </li>
                    {/* <li className="nav-item" style={{cursor: 'pointer'}}>
                        <div className={`nav-link ${tab === 'archieved' ? 'active' : ''} px-1`} onClick={() => setTab('archieved')}>Archived</div>
                    </li> */}
                </ul>
            </div>
        </div>
    )
}

const BeatSpinner2 = ({loading}:any) => {
    return (
        <div className = 'd-flex align-items-center justify-content-center' style = {{height: '60vh'}}>
            <BeatLoader size={15} color={"#2c7be5"} loading={loading}/>
        </div>
    )
}

const headers = [
    {value: 'name', active: true, label: 'Name'},
    {value: 'email', active: true, label: 'Email'},
    {value: 'phone', active: true, label: 'Phone'},
    {value: 'signupDate', active: true, label: 'Sign up Date'},
    {value: 'rating', active: true, label: 'Rating'},
    {value: 'approved', active: true, label: 'Is Approved'},
    {value: 'onboarded', active: true, label: 'Is Onboarded'},
    {value: 'instrument_teach', active: true, label: 'Instrument'},
    {value: 'hideUser', active: true, label: 'Hide'},
    {value: 'isEdited', active: true, label: 'Edited'},
]

const NameWithAvatar = ({name, avatar}:any) => {
    return (
        <>
       
        <span className="item-name text-reset">{name}</span>
        </>
    )
}